/** @jsx jsx */
import { truncate } from 'lodash';
import { jsx, css } from '@emotion/core';

import { Colors, Grid, Text } from '@zapier/design-system';

import Accordion from 'app/common/components/Accordion';
import { convertPlainTextToHtml } from 'app/developer-v3/utils';

const Styles = {
  container: css`
    background-color: ${Colors.GrayWarm2};
    display: block;
    unicode-bidi: embed;
    overflow: auto;
    padding: 10px;
  `,
};

type Props = {
  isInitiallyExpanded: boolean;
  date: string;
  title: string;
  message: string;
};

const SimpleLog = ({ isInitiallyExpanded, date, title, message }: Props) => {
  const accordionTitle = (
    <Grid columns="repeat(2, 1fr)" gap={20}>
      <Text fontWeight={600}>{truncate(title, { length: 40 })}</Text>
      <Text textAlign="right">{date}</Text>
    </Grid>
  );

  return (
    <Accordion
      aria-label="Simple Log container"
      isInitiallyOpen={isInitiallyExpanded}
      title={accordionTitle}
    >
      <div css={Styles.container}>
        <pre
          dangerouslySetInnerHTML={{
            __html: convertPlainTextToHtml(message),
          }}
        />
      </div>
    </Accordion>
  );
};

export default SimpleLog;
